import * as React from 'react';
type Props = {
  className?: string;
};
export function CaretUp({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-caret-up"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2426 15.571L17.6568 14.1568L12 8.49998L6.34314 14.1568L7.75735 15.571L12.0001 11.329L16.2426 15.571Z"
        fill="currentColor"
      />
    </svg>
  );
}
